import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex, Select as ThemeUiSelect, Label } from 'theme-ui'

import Text from '~/components/IntlComponents/Text'

const Select = forwardRef(
  ({ label, children, errorText, sx, ...props }, ref) => {
    const wrapperStyle = {
      width: '100%',
      flexFlow: 'wrap column',
      ...sx,
    }

    const labelStyle = {
      fontFamily: 'heading',
      marginBottom: '10px',
      color: 'secondary',
    }

    const errorStyle = {
      color: 'error',
      fontWeight: 'body',
      marginTop: '6px',
    }

    return (
      <Flex sx={wrapperStyle}>
        {label && (
          <Label htmlFor={props.name} sx={labelStyle}>
            {label}
          </Label>
        )}
        <ThemeUiSelect
          arrow={
            <Box
              as="svg"
              width="11"
              height="6"
              viewBox="0 0 11 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              sx={{
                ml: -28,
                alignSelf: 'center',
                pointerEvents: 'none',
              }}
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.01213 6L10.002 0.863219L9.14367 0L4.99197 4.27397L0.840277 0L0.00195312 0.863219L4.99177 6H5.01213Z"
                fill="#2B38BD"
              />
            </Box>
          }
          {...props}
          variant="forms.input.gift"
          ref={ref}
        >
          <option value=""></option>
          {children}
        </ThemeUiSelect>
        {errorText && <Text sx={errorStyle}>{errorText}</Text>}
      </Flex>
    )
  },
)

Select.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.array,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  errorText: PropTypes.string,
  sx: PropTypes.object,
}

export default Select
